import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	progressHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	progressHeading: {
		id: 'version-progress.progress-heading',
		defaultMessage: 'Progress',
		description: "Title for a section of the UI that shows the releases's progress",
	},
});
